import { render, staticRenderFns } from "./InviteView.vue?vue&type=template&id=0bf46e48&scoped=true&"
import script from "./InviteView.vue?vue&type=script&lang=js&"
export * from "./InviteView.vue?vue&type=script&lang=js&"
import style0 from "./InviteView.vue?vue&type=style&index=0&id=0bf46e48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf46e48",
  null
  
)

export default component.exports